// components/branding/CenterBrandingHeader.js
import React, { useContext } from 'react';
import { useSubdomain } from '../../contexts/SubdomainContext';
import AuthContext from '../../contexts/AuthContext';
import './CenterBrandingHeader.css';

/**
 * CenterBrandingHeader component displays center's branding (logo and name)
 * This component is similar to the mobile version but adapted for web
 * It uses either the center from the subdomain or the one from auth context
 */
const CenterBrandingHeader = () => {
  // Use center data from subdomain provider first, then fall back to auth context
  const { center: subdomainCenter, subdomain, hasFeature } = useSubdomain();
  const { center: authCenter } = useContext(AuthContext);
  
  // Use subdomain center if available, otherwise fall back to auth center
  const center = subdomainCenter || authCenter;
  
  // ALWAYS render a branding header, even when no center data is available
  // This ensures the header is visible immediately on all screens, including after login
  // and prevents layout shifts when real data becomes available
  
  if (!center || !hasFeature) {
    // Render default branding when no center data is available
    return (
      <div className="center-branding-header" style={{ backgroundColor: '#4a90e2' }}>
        <div className="center-logo-placeholder" style={{ backgroundColor: '#2979c0' }}>
          <span className="center-initial">M</span>
        </div>
        <h1 className="center-name" style={{ color: 'white' }}>memorAIze</h1>
      </div>
    );
  }
  
  // Get first letter for placeholder
  const centerInitial = center?.name?.charAt(0) || 'M';
  
  // Apply branding colors if available
  const headerStyle = center.brandingSettings?.primaryColor ? 
    { backgroundColor: center.brandingSettings.primaryColor } : {};
  
  // Always set text color to white as per requirements
  const textStyle = { color: 'white' };

  const placeholderStyle = center.brandingSettings?.accentColor ?
    { backgroundColor: center.brandingSettings.accentColor } : {};
    
  return (
    <div className="center-branding-header" style={headerStyle}>
      {center.logoUrl ? (
        <div className="center-logo-container">
          <img 
            src={center.logoUrl} 
            alt={`${center.name} logo`}
            className="center-logo" 
          />
        </div>
      ) : (
        <div className="center-logo-placeholder" style={placeholderStyle}>
          <span className="center-initial">{centerInitial}</span>
        </div>
      )}
      <h1 className="center-name" style={textStyle}>{center?.name || 'memorAIze'}</h1>
      
      {/* Subdomain badge removed as requested */}
    </div>
  );
};

export default CenterBrandingHeader;